var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReturnCircleIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon return-circle-icon",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82 2.783a.5.5 0 01.107.644l-.043.06-.78.936A4.5 4.5 0 113.5 8.833a.5.5 0 011 0 3.5 3.5 0 102.595-3.382l1.362.975a.5.5 0 01.155.635l-.038.063a.502.502 0 01-.635.155l-.063-.039-2.333-1.666a.502.502 0 01-.136-.67l.042-.057 1.667-2a.499.499 0 01.704-.064z"
  }))));
}

export default SvgReturnCircleIconSv;